import { AddToCartIcon } from "../_icons/addToCartIcon";

export const ItemsAddedToCartBanner = () => {
  return (
    <div
      data-testid="items-added-to-cart-banner"
      className="bg-[#F2FCEE] rounded-lg border border-[#228800] w-[249px] gap-4 flex p-3"
    >
      <AddToCartIcon />
      <div>
        <p className="font-medium text-[15px] pb-2">Items added to cart</p>
        <p className="text-[14px]">
          Tap cart to send your items to the kitchen.
        </p>
      </div>
    </div>
  );
};
